import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const usePageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '1450px',
        minHeight: '537px',
        ...shorthands.margin('auto'),
        ...shorthands.padding(tokens.spacingVerticalXXXL, '0'),
        ...shorthands.gap(tokens.spacingVerticalXXXL),
        '@media screen and (max-width: 1500px)': {
            width: '95%'
        },
        '@media screen and (max-width: 480px)': {
            width: '90%'
        }
    }
});
